import React from 'react';
import NewGtinPrefixForm from '../components/NewGtinPrefixForm';

const NewGtinPrefixPage: React.FC = () => {
  return (
    <NewGtinPrefixForm
      onSuccess={() => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/admin/manufacturer_management?activeTab=4`;
      }}
    />
  );
};

export default NewGtinPrefixPage;
